
import React, {FC} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

import InfoIcon from './svgs/info.inline.svg';

import * as styles from './styles.module.scss';

export type ItemProps = {
	title: string
	text: string
	hover?: string
}

const Item: FC<ItemProps> = ({title, text, hover}) => {
	const icon = !hover ? null : (
		<OverlayTrigger
			overlay={(props) => (
				<Tooltip {...props} className={styles.tooltip}>
					{hover}
				</Tooltip>
			)}
		>
			<div><InfoIcon /></div>
		</OverlayTrigger>
	);

	return (
		<div className={styles.item}>
			<h2>{title}</h2>
			<span>
				{text} {icon}
			</span>
		</div>
	);
};

export default Item;
